// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LoginPage from "./components/screens/login/Login";
import Collect from "./components/screens/collect/Collect"; // Assuming you have a Collect component
import Home from "./components/screens/home/Home";
import Print from "./components/screens/print/Print";
import BluetoothTest from "./services/BluetoothTest"; // Importing BluetoothTest component
import Sms from "./components/screens/sms/Sms";
import Report from "./components/screens/report/Report";

import { AuthProvider } from "./components/ContextApi/ContextApi";
import ReadReport from "./components/screens/ReadReport/ReadReport";
import Navbar from "./components/shared/Navbar";
import ProfilePage from "./components/screens/Profile/Profile";
import AddAccount from "./components/screens/addNewAcc/AddAccount";
import PrintReport from "./components/screens/report/PrintReport";
import ReportBluetooth from "./services/ReportBluetooth";
import AccountCards from "./components/screens/addNewAcc/NewAccount";
// import SuperAdminLoginPage from "./components/screens/SuperAdmin/Login/Login";
// import Dashboard from "./components/screens/SuperAdmin/Login/Dashboard/Dashboard";
import NewAccountReportBluetooth from "./services/NewAccountReportBluetooth";
import ViewOldNewAccounts from "./components/screens/viewAllAcc/ViewAllAccounts";
import ViewOldNewAccountsReportBluetooth from "./services/ViewOldNewAccountsReportBluetooth";

function App() {
  return (
    <Router>
      <AuthProvider>

   
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route path="/collect" element={<Collect />} />
          <Route path="/Home" element={<Home />} />
           <Route path="/Print" element={<Print />} />
           <Route path="/BluetoothTest" element={<BluetoothTest />} />
            <Route path="/Sms" element={<Sms />} />
             <Route path="/Report" element={<Report />} />
             <Route path="/ReadReport" element={<ReadReport />} />
                  <Route path="/Navbar" element={<Navbar />} />
             <Route path="/add-account" element={<AddAccount />} />
             <Route path="/print-report" element={<PrintReport />} />
             <Route path="/report-bluetooth"element={<ReportBluetooth />} />
             <Route path="/new-account" element={<AccountCards />} />
             <Route path="/newaccount-report-bluetooth" element={<NewAccountReportBluetooth />} />
              <Route path="/view-old-new-accounts" element={<ViewOldNewAccounts/>} />
              <Route path="/old-new-accounts-reports" element={<ViewOldNewAccountsReportBluetooth/>} />


 <Route path="/Profile" element={<ProfilePage />} />

             {/* <Route path="/SuperAdminLogin" element={<SuperAdminLoginPage />} />
             <Route path="/SuperAdminDashboard" element={<Dashboard />} /> */}
        </Routes>
     </AuthProvider>
    </Router>
  );
}

export default App;
